var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 31,
    viewBox: "0 0 27 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.43359 5.16309V24.3298C1.43359 27.0912 3.67217 29.3298 6.4336 29.3298H21.7336",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3003 0.330078C7.53887 0.330078 5.30029 2.56865 5.30029 5.33007V20.4634C5.30029 23.2248 7.53887 25.4634 10.3003 25.4634H21.567C24.3284 25.4634 26.567 23.2248 26.567 20.4634V5.33008C26.567 2.56865 24.3284 0.330078 21.567 0.330078H10.3003ZM21.0705 4.33005L15.4538 4.33005C13.5726 4.33005 11.6908 4.33015 9.80836 4.33035C9.47263 4.33035 9.30028 4.51231 9.30028 4.86853V7.53479C9.30028 7.90086 9.47263 8.08004 9.81732 8.08004L21.0916 8.08005C21.438 8.08005 21.6062 7.90147 21.6062 7.53417V4.89747C21.6062 4.49753 21.448 4.33005 21.0705 4.33005ZM13.8088 10.0729H17.7852C18.1608 10.0729 18.3246 10.2441 18.3246 10.6367V13.2879C18.3246 13.6374 18.1477 13.8228 17.8136 13.8228H9.80466C9.48081 13.8228 9.30066 13.634 9.3003 13.2956L9.3003 10.6003C9.3003 10.2616 9.47975 10.0732 9.80431 10.0729C11.1394 10.0727 12.4742 10.0727 13.8088 10.0729ZM14.5051 15.8162H12.1719C11.3892 15.8152 10.6064 15.8151 9.82325 15.8159C9.49739 15.8165 9.30029 16.0071 9.30029 16.3245V19.0493C9.30067 19.3757 9.49551 19.5653 9.83151 19.5653L14.5126 19.5653C14.8493 19.5653 15.0431 19.3766 15.0431 19.049V16.3396C15.0431 16.0009 14.8538 15.8162 14.5051 15.8162Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResources);
export default __webpack_public_path__ + "static/media/icon_resources.fda6742fc2d46ad37a5fccc37915ce1c.svg";
export { ForwardRef as ReactComponent };